import { isMapPath } from './mapParamsState.js';

// URL reported to analytics as page_location. /map never reports a query string;
// elsewhere the party names are dropped.
const PARTY_PARAMS = ['importer', 'exporter'];

export const sanitizePageLocation = (href) => {
  let url;
  try {
    url = new URL(href);
  } catch {
    return href;
  }
  if (isMapPath(url.pathname)) return url.origin + url.pathname;
  for (const key of PARTY_PARAMS) url.searchParams.delete(key);
  return url.toString();
};
